import { DollarSign } from 'lucide-react';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';

interface PriceFromEditorProps {
  label: string; // C'est ici qu'on stocke le prix formaté (ex: "5 000 FCFA")
  detail: string; // Ex: "Hors Taxes / demi-journée"
  onChange: (updates: { priceFromLabel?: string; priceFromDetail?: string }) => void;
}

export function PriceFromEditor({ label, detail, onChange }: PriceFromEditorProps) {
  return (
    <div className="bg-white border-2 border-gray-100 rounded-[32px] p-8 shadow-sm hover:shadow-md transition-all relative overflow-hidden group">
      {/* Background Decorative Element */}
      <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-gray-50 rounded-full opacity-50 group-hover:scale-110 transition-transform duration-700" />

      <div className="relative z-10 space-y-6">
        <div className="flex items-center gap-3 border-b border-gray-50 pb-4">
          <div className="w-10 h-10 rounded-xl bg-[#00303c] text-white flex items-center justify-center shadow-lg shadow-[#00303c]/20">
            <DollarSign size={20} />
          </div>
          <div>
            <h4 className="font-black text-[#00303c] uppercase tracking-tight text-sm">Badge de prix d'appel</h4>
            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
              S'affiche en haut de la carte espace
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-6 space-y-2">
            <div className="flex items-center gap-2">
              <Label className="text-[9px] font-black uppercase tracking-widest text-gray-400 block ml-1">
                Prix à afficher (Large)
              </Label>
            </div>
            <Input
              value={label}
              onChange={(e) => onChange({ priceFromLabel: e.target.value })}
              className="h-12 text-lg font-black bg-gray-50/50 rounded-2xl border-gray-200 focus:border-[#00303c] focus:ring-4 focus:ring-[#00303c]/5 transition-all shadow-none text-[#00758d]"
              placeholder="Ex: 5 000 FCFA"
            />
          </div>

          <div className="col-span-6 space-y-2">
            <div className="flex items-center gap-2">
              <Label className="text-[9px] font-black uppercase tracking-widest text-gray-400 block ml-1">
                Précision / Durée (Petit)
              </Label>
            </div>
            <Input
              value={detail}
              onChange={(e) => onChange({ priceFromDetail: e.target.value })}
              className="h-12 text-xs font-bold bg-gray-50/50 rounded-2xl border-gray-200 focus:border-[#00303c] focus:ring-4 focus:ring-[#00303c]/5 text-gray-500 shadow-none"
              placeholder="Ex: Hors Taxes / demi-journée"
            />
          </div>
        </div>

        {/* Visual Mockup of the badge */}
        <div className="pt-4 mt-2 flex flex-col items-center">
          <div className="text-[9px] font-black uppercase tracking-widest text-gray-300 mb-3 flex items-center gap-2">
            <div className="h-[1px] w-8 bg-gray-100"></div>
            Rendu Visuel sur le site
            <div className="h-[1px] w-8 bg-gray-100"></div>
          </div>

          <div className="relative group-hover:scale-105 transition-transform duration-500">
            {/* Simulation de la carte espace */}
            <div className="w-64 h-40 bg-gray-100 rounded-2xl border border-gray-200 overflow-hidden relative shadow-lg">
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute bottom-3 left-3 text-white font-bold text-xs">Exemple d'Espace</div>

              {/* Le Badge Réel */}
              <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-md border border-white/20 rounded-xl p-2 px-4 flex flex-col items-end min-w-[100px]">
                <span className="text-[8px] font-black text-white/60 uppercase tracking-widest">À partir de</span>
                <span className="text-sm font-black text-white leading-none my-0.5">{label || '...'}</span>
                <span className="text-[8px] font-medium text-white/50">{detail || '...'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
